import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: 5,
    background: '#fff',
  },
  input: {
    width: '100%',
    maxWidth: 120,
    minHeight: 24,
    fontSize: '1rem',
    fontFamily: 'NeoSansStd',
    background: 'transparent',
    border: 0,
    color: theme.custom.darkBlue,
    outline: 'none',
    '&:active, &:focus': {
      outline: 'none',
    },
    '&::-webkit-input-placeholder': {
      color: 'currentColor',
      opacity: 0.42,
    },
  },
  disabled: {
    opacity: 0.5,
  },
  icon: {
    color: theme.custom.darkBlue,
    cursor: 'pointer',
  },
  disabledIcon: {
    cursor: 'default',
    opacity: '.5',
  },
  underline: {
    borderBottom: '1px solid rgba(34, 64, 96, 0.2)',
  },
}));
